var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.schema.sections)?_c('div',{staticClass:"ls-form"},_vm._l((_vm.notEmptySection),function(section,index){return _c('t-ls-section',{key:index,attrs:{"index":index,"schema":section,"data":_vm.data,"context":_vm.context},on:{"input":_vm.simpleEmit}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }